import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import ROUTES from '@/common/routes';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { useInvestor } from '@/modules/investments/hooks';
import SelfDirectedAllocation from '@/modules/investments/SelfDirected/SelfDirectedAllocation';
import { useMyEnrollments } from '@/modules/transaction';

const SelfDirectedSwitchEmptyAllocationPage = () => {
  const { accountId = '' } = useParams<{ accountId: string }>();

  const {
    data: { investorId },
  } = useInvestor(accountId);
  const { t } = useTranslation();
  const { currentMyAccount } = useMyEnrollments(accountId);
  useBreadcrumbs([{
    key: ROUTES.HOME,
    title: t('Home'),
    value: ROUTES.HOME,
  },
  {
    key: ROUTES.MY_ACCOUNTS_DETAILS(currentMyAccount?.id),
    title: currentMyAccount?.accountType,
    value: ROUTES.MY_ACCOUNTS_DETAILS(currentMyAccount?.id),
  },
  {
    key: ROUTES.START_INVESTING,
    title: t('Start Investing'),
    value: ROUTES.START_INVESTING,
  }], true); 
 
     
  if (!accountId || !investorId) {
    return null;
  }

  return (
    <SelfDirectedAllocation
      isSwitchMode
      isEmptyPortfolioMode
      accountId={accountId}
      investorId={`${investorId || ''}`}
    />
  );
};
export default SelfDirectedSwitchEmptyAllocationPage;
